import React from "react";

export default function SectionCard({ title, subtitle, action, children }) {
  return (
    <section className="soft-card p-3 sm:p-5">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h2 className="text-base font-extrabold text-brand-800 sm:text-lg">{title}</h2>
          {subtitle ? (
            <p className="mt-1 text-xs leading-6 text-slate-500 sm:text-sm">{subtitle}</p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
      {children}
    </section>
  );
}
